<template>
  <div class="case-page">
    <header>
      <div class="normal-header-block">
        <div class="container">
          <div class="slogan-container">
            <h1>和鲸获得了<br/>行业顶尖客户的认可</h1>
          </div>
        </div>
      </div>
    </header>
    <section>
      <div class="bg-block bg-case">
        <div class="case-container container">
        <span class="nav-text" @click="navTo('about')">关于我们</span> > <span class="nav-text" @click="navTo('partner')">客户案例</span> > {{currentCase.Name}}
          <div class="case-content">
            <div class="case-side-bar">
              <div class="case-side-bar-header">
                <h2>客户案例</h2>
                <h3>Heywhale Case</h3>
              </div>
              <div class="case-logo-container">
                <img :src="`https://cdn.kesci.com/client/logo/v2/${currentCase.ShortName}.png`">
              </div>
            </div>
            <div class="case-main-container">
              <div class="case-intro-container">
                <h2>{{currentCase.Name}}</h2>
                <p>{{currentCase.Intro}}</p>
              </div>
              <div class="case-solution-container">
                <div class="case-main-header">
                  <h3>解决方案</h3>
                </div>
                <p>{{currentCase.Solution}}</p>
                <div class="case-solution-gallery">
                  <img v-for="(img, index) in currentCase.SolutionImg" :key="index" :src="`https://cdn.kesci.com/client/solution/${img}.png`">
                </div>
              </div>
              <div class="case-task-container">
                <div class="case-main-header">
                  <h3>项目课题</h3>
                </div>
                <div class="case-task-card" v-for="(item, index) in currentCase.Task" :key="index">
                  <div class="case-vice-header">
                    <h5>{{item.Title}}</h5>
                  </div>
                  <p>{{item.Detail}}</p>
                </div>
              </div>
              <div class="case-gallery-container">
                <div class="case-flex-wrapper">
                  <img v-for="(img, index) in currentCase.Gallery" :key="index" :src="`https://cdn.kesci.com/client/gallery/${img}`">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import cases from '../data/case.json';
export default {
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      const name = to.params.id;
      vm.currentCase = cases.find((r) => {
        return r.ShortName === name;
      });
    });
  },
  data() {
    return {
      currentCase: {}
    };
  },
  methods: {
    navTo(name) {
      this.$router.push({
        name
      });
    }
  }
};
</script>

<style lang="scss">
.case-page {
  .normal-header-block {
    background-image: url("../assets/banners/partner.jpg");
  }
  h2 {
    font-weight: 500;
  }
  p {
    color: #002040;
    margin: 0;
  }
  .nav-text {
    cursor: pointer;
  }
  .bg-case {
    padding: 12px 0px 36px 0px;
  }
  .case-content {
    display: flex;
    margin-top: 12px;
  }
  .case-side-bar {
    width: 300px;
    margin-right: 24px;
    flex-shrink: 0;
    h2, h3 {
      color: #fff;
      margin: 0px;
    }
  }
  .case-side-bar-header {
    padding: 24px 28px;
    background-image: url('../assets/bg-user-card.png');
    background-position: center bottom;
  }
  .case-logo-container {
    background-color: #fff;
    height: 260px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .case-main-container {
    background-color: #fff;
    flex-grow: 1;
    padding: 32px 48px;
    h2 {
      margin: 0px 0px 24px 0px;
    }
  }
  .case-intro-container {
    margin-bottom: 56px;
  }
  .case-solution-container {
    margin-bottom: 56px;
  }
  .case-solution-gallery {
    display: flex;
    flex-wrap: wrap;
    img {
      height: 24px;
      width: auto;
      margin: 24px 32px 0px 0px;
    }
  }
  .case-main-header {
    background-image: url('../assets/bg-case-main-header.png');
    background-size: cover;
    color: #fff;
    margin-bottom: 16px;
    padding: 4px 16px;
    border-radius: 4px;
  }
  .case-vice-header {
    background-color: rgba(2, 110, 255, 0.1);
    padding: 4px 8px;
    margin: 32px 0px 16px 0px;
    h5 {
      padding-left: 24px;
      background-image: url('../assets/list-style-circle.svg');
      background-repeat: no-repeat;
      background-position: left center;
    }
  }
  .case-task-card {
    margin-bottom: 32px;
  }
  .case-task-container {
    margin-bottom: 48px;
  }

  .case-gallery-container {
    width: 100%;
    height: 140px;
    overflow: hidden;
    .case-flex-wrapper {
      overflow-x: scroll;
      max-width: 720px;
      display: flex;
      img {
        height: 140px;
        width: auto;
        margin-right: 16px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/case.vue